import { render, staticRenderFns } from "./Step2LeadLovers.vue?vue&type=template&id=0a509ee1&scoped=true&"
import script from "./Step2LeadLovers.vue?vue&type=script&lang=js&"
export * from "./Step2LeadLovers.vue?vue&type=script&lang=js&"
import style0 from "./Step2LeadLovers.vue?vue&type=style&index=0&id=0a509ee1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a509ee1",
  null
  
)

export default component.exports